import OSS from 'ali-oss';

import http from '../router/axios';

const OSS_URL = '/trm/system/getOssToken';
const OSSConfig = {
  region: 'oss-cn-shanghai',
  bucket: 'woordee',
};
const RRWEB_FOLDER = 'rrweb';
let client = null;

export const getSign = () => {
  if (client) {
    return new Promise((resolve) => {
      resolve(client);
    });
  }
  return http.get(OSS_URL).then((res) => {
    const { accessKeyId, accessKeySecret, securityToken } = res.data.data;
    client = new OSS({
      region: OSSConfig.region,
      accessKeyId,
      accessKeySecret,
      stsToken: securityToken,
      bucket: OSSConfig.bucket,
    });
    return client;
  });
};

export const uploadBlob = (blob) => {
  return getSign()
    .then((client) => {
      const filepath = `${RRWEB_FOLDER}/examplefile-${Date.now()}.txt`;
      return client.put(filepath, blob);
    })
    .then((res) => {
      return res.res.requestUrls[0];
    })
    .catch((err) => {
      console.error(err);
    });
};
